
let warn = null;
function _warnElement() {
	if (warn !== null) return warn;
	warn = document.createElement("div");
	warn.style.position = "fixed";
	warn.style.top = "0";
	warn.style.right = "0";
	warn.style.maxWidth = "600px";
	warn.style.padding = "8px";
	warn.style.backgroundColor = "#DD3300";
	warn.style.color = "#FFFFFF";
	warn.style.zIndex = "100000";
	warn.style.maxHeight = "600px";
	warn.style.overflowY = "auto";
	warn.style.overflowX = "auto";
	warn.style.fontFamily = "Consolas, Monaco, \"Lucida Console\", \"Andale Mono\", monospace";
	warn.style.fontSize = "12px";
	const body = document.querySelector("body");
	body.insertBefore(warn, body.firstChild);
	return warn;
}
function _appendParagraph(container, text) {
	const para = document.createElement("div");
	para.appendChild(document.createTextNode(text));
	container.appendChild(para);
}

/**
 * @param {string} message - error message. Available as event (sic!) in HTML onerror="" handler.
 * @param {string} source - URL of the script where the error was raised
 * @param {number} lineno - Line number where error was raised
 * @param {number} colno - Column number for the line where the error occurred
 * @param {?object} error - Error Object. May be null if no corresponding Error Object is available.
 */
function onError(message, source, lineno, colno, error) {
	console.log(message + "\n" + source + " - " + lineno + ":" + colno);
	if (typeof navigator.sendBeacon === 'function') {
		const data = {};
		data.message = message;
		data.source = source;
		data.line = lineno;
		data.column = colno;
		data.location = window.location.href;
		const reported = navigator.sendBeacon("./ajax/beacon.jsp", JSON.stringify(data));
	}
	if (window.location.port !== '') {	// non-standard port (gues we are running in development env)
		const w = _warnElement();
		_appendParagraph(w, message.toString());
		_appendParagraph(w, lineno + ":" + colno + " @ " + source);
	}
};

window.onerror = onError;
export default onError;
